export default __webpack_public_path__ + "static/media/timeline.2f3ca2dc.png";